import { ChangeEvent, useEffect, useState } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';

import styles from './KnmChangeControllingSubjectStpModal.module.scss';

interface IKnmChangeControllingSubjectStpModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (changeReason: string) => void;
}

export const KnmChangeControllingSubjectStpModal = ({
  visible,
  onClose,
  onConfirm,
}: IKnmChangeControllingSubjectStpModalProps) => {
  const [changeReason, setChangeReason] = useState<string>('');

  useEffect(() => {
    if (visible) {
      setChangeReason('');
    }
  }, [visible]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setChangeReason(e.target.value);

  const handleConfirm = () => {
    const trimmed = changeReason.trim();

    if (trimmed) {
      onConfirm(trimmed);
    }
  };

  return (
    <Modal visible={visible} onClose={onClose} modalBodyClassName={styles.Modal}>
      <ModalHeader title="Смена КЛ" />
      <ModalBody size="content">
        <Row>
          <FieldBlock label="Основание замены" color="black">
            <TextInput placeholder="Основание" value={changeReason} onChange={handleChange} />
          </FieldBlock>
        </Row>
      </ModalBody>
      <ModalActions>
        <Button
          text="Сохранить"
          color="primary"
          size="medium"
          onClick={handleConfirm}
          disabled={!changeReason.trim()}
        />
        <Button text="Отмена" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
